import { render, staticRenderFns } from "./TeamSales.vue?vue&type=template&id=10e7282b&scoped=true"
import script from "./TeamSales.vue?vue&type=script&lang=js"
export * from "./TeamSales.vue?vue&type=script&lang=js"
import style0 from "./TeamSales.vue?vue&type=style&index=0&id=10e7282b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e7282b",
  null
  
)

export default component.exports